import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TextMaskModule } from 'angular2-text-mask';
import { UserFormComponent } from './user-form.component';
import { SharedModule } from '../../../../shared/shared.module';
import { AdminAccess } from '../../../../shared/accessAdmin';
import { FlexLayoutModule } from '@angular/flex-layout';
import { AppMaterialModule } from '../../../../shared/appMaterial/app-material.module';
import { EnrollEmailDuplicateModule } from '../../../../shared/enrollEmailDuplicate/enroll-email-duplicate.module';
import { EqualValidatorModule } from '../../../../shared/equalValidator/equal-validator.module';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    AppMaterialModule,
    SharedModule,
    TextMaskModule,
    FlexLayoutModule,
    EnrollEmailDuplicateModule,
    EqualValidatorModule,
    MatDatepickerModule,
  ],
  declarations: [UserFormComponent],
  exports: [UserFormComponent],
  providers: [
    AdminAccess,
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { floatLabel: 'always' },
    },
  ],
})
export class UserFormModule {}
